import { connect } from 'react-redux';
import PastMeetingsTab from 'components/DashboardNew/PastMeetingsTab/PastMeetingsTab';
import { selectFilterString } from 'selectors/filterSelectors';
import { selectPageNumber } from 'selectors/paginationSelectors';
import { selectSort } from 'selectors/sortSelectors';
import { Global } from 'state/Global';
import actions from 'actions/sortActions';
import { SortDirection } from 'constants/queryConstants';

interface SetSortInterface {
  sortBy: string;
  order: string;
}

function mapStateToProps(state: Global) {
  const dashboardState = state.app.get('dashboard', null);
  const pageNumber = selectPageNumber(state);
  const search = selectFilterString(state);
  const sort = selectSort(state) || {
    cursor: '',
    search: '',
    sortBy: 'startedAt',
    order: SortDirection.DESC,
  };

  const dateStart = new Date(dashboardState.startDateMoment.format('YYYY/MM/DD'));
  dateStart.setHours(0);
  dateStart.setMinutes(0);
  dateStart.setSeconds(0);
  const dateEnd = new Date(dashboardState.endDateMoment.format('YYYY/MM/DD'));
  dateEnd.setHours(23);
  dateEnd.setMinutes(59);
  dateEnd.setSeconds(59);
  return {
    startTimestamp: dateStart.getTime() / 1000,
    endTimestamp: dateEnd.getTime() / 1000,
    search,
    sort,
    pageNumber
  };
}

const mapDispatchToProps = (dispatch: Function) => ({
  setSort: (sort: SetSortInterface) => dispatch(actions.setSort(sort))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PastMeetingsTab);
